export default {
	lang: {
		set (value) {
			if (value === 'en-gb') {
				value = 'en'
			}
			document.documentElement.lang = value
		},
		get () {
			return document.documentElement.lang
		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/document.js